import {AfterViewInit, Component, ElementRef, OnInit, Renderer} from '@angular/core';
import {JhiLanguageService} from 'ng-jhipster';
import {TranslateService} from 'ng2-translate';

import {Register} from './register.service';
import {ActivatedRoute, Router} from '@angular/router';

import {CALENDAR_FR} from '../../shared/calendar/calendar.constants';
import {ParametrageService} from '../../entities/parametrage';
import {Response} from '@angular/http';

@Component({
    selector: 'jhi-register',
    templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit, AfterViewInit {

    confirmPassword: string;
    doNotMatch: string;
    error: string;
    errorEmailExists: string;
    errorTestEmail: string;
    registerAccount: any;
    success: boolean;
    fr: any;
    routeData: any;
    createUser = false;
    parametrage: any;
    currentLang: string;

    constructor(
        private languageService: JhiLanguageService,
        private registerService: Register,
        private elementRef: ElementRef,
        private renderer: Renderer,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private parametrageService: ParametrageService,
        private translate: TranslateService
    ) {
        this.languageService.setLocations(['register']);
    }

    ngOnInit() {
        this.success = false;
        this.registerAccount = {};
        this.fr = CALENDAR_FR;
        this.activatedRoute.params.subscribe(params => {
            this.createUser = params['createUser'];
         });
        this.parametrageService.queryPageEspaceConnexion().subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
            });
        this.currentLang = '' + this.languageService.currentLang;
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang);
    }

    ngAfterViewInit() {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    }

    register() {
        if (this.registerAccount.password !== this.confirmPassword) {
            this.doNotMatch = 'ERROR';
        } else {
            this.doNotMatch = null;
            this.error = null;
            this.errorEmailExists = null;
            this.languageService.getCurrent().then(key => {
                this.registerAccount.langKey = key;
                this.registerAccount.login = this.registerAccount.email;
                this.registerService.save(this.registerAccount).subscribe(() => {
                    this.router.navigate(['/register-confirmation']);
                    this.success = true;
                }, (response) => this.processError(response));
            });
        }
    }

    openLogin() {
        this.router.navigate(['/login']);
    }

    private processError(response) {
        this.success = null;
        if (response.status === 400 && response._body === 'userexists') {
            this.errorEmailExists = 'ERROR';
        } else {
            if (response._body.toUpperCase().indexOf('SENDFAILEDEXCEPTION') >= 0) {
                this.errorTestEmail = 'ERROR';
            } else {
                this.error = 'ERROR';
            }

        }
    }

    getConnexionMessage(langue: String): String {
        if (langue && langue === 'en') {
            return this.parametrage.MESSAGE_INSCRIPTION.libelleEn;
        } else {
            return this.parametrage.MESSAGE_INSCRIPTION.libelle;
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/register.component.ts